import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PropertyPortfolioCard = ({ property, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'مؤجر':
        return 'bg-success/10 text-success border-success/20';
      case 'شاغر':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'صيانة':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-warm transition-all duration-250">
      <div className="relative h-40 md:h-48 overflow-hidden">
        <Image
          src={property?.image}
          alt={property?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-2 right-2">
          <span
            className={`px-3 py-1 rounded-full text-xs font-caption border ${getStatusColor(
              property?.status
            )}`}
          >
            {property?.status}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h4 className="font-heading font-semibold text-foreground text-sm md:text-base mb-2 line-clamp-1">
          {property?.title}
        </h4>

        <p className="text-xs md:text-sm text-muted-foreground mb-3 line-clamp-2">
          {property?.address}
        </p>

        <div className="grid grid-cols-2 gap-2 mb-3">
          <div className="flex items-center gap-2">
            <Icon name="DollarSign" size={14} color="var(--color-primary)" />
            <div>
              <p className="text-xs text-muted-foreground">الإيراد الشهري</p>
              <p className="text-sm font-data font-semibold text-foreground">
                {property?.monthlyRevenue}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Calendar" size={14} color="var(--color-primary)" />
            <div>
              <p className="text-xs text-muted-foreground">الصيانة القادمة</p>
              <p className="text-xs font-data text-foreground">
                {property?.nextMaintenance}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 pt-3 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Eye"
            iconSize={16}
            onClick={() => onViewDetails(property)}
          >
            عرض التفاصيل
          </Button>
          <Button
            variant="ghost"
            size="icon"
            iconName="MapPin"
            iconSize={16}
            onClick={() => console.log('Show on map', property?.id)}
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyPortfolioCard;